module.exports = __webpack_public_path__ + "static/media/swap.a40edfd5.svg";